module.exports = __webpack_public_path__ + "static/frontier-logo-a2ad95394019782a59c5238e5ca49033.png";